/**
 * @file: serviceSubjectEquals.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { ServiceSubject } from '@euler/model';
import { ServiceSubjectType } from '@euler/model/enum';

export const serviceSubjectEquals = (x: ServiceSubject, y: ServiceSubject) => {
  if (
    x.type === ServiceSubjectType.Inspection &&
    y.type === ServiceSubjectType.Inspection
  ) {
    return x.templateId === y.templateId;
  }
  return x.type === y.type && x.name === y.name;
};
